import { Text } from './Text';

interface VersionRowProps {
  label: string;
  version?: string;
  revision?: string;
}

export function VersionRow({ label, version, revision }: VersionRowProps) {
  const hasRevision = revision !== undefined && revision !== null;
  const versionText = `${version || '--'}${hasRevision ? ` | ${revision || '--'}` : ''}`;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        minWidth: 0
      }}
    >
      <Text variant='body2-bold'>{label}</Text>
      <Text
        variant='body2'
        style={{
          marginLeft: 'auto',
          minWidth: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          color: 'var(--text-secondary)'
        }}
      >
        {versionText}
      </Text>
    </div>
  );
}
